<template>
  <div class="text-float" :style="fontStyle">
    <!-- style="color: rgba(0, 0, 0, 0)" 为占位字符 -->
    <!-- TODO  calc -->
    <!-- this.scale{{ this.scale }} -->
    <span class="flex">
      <div class="miniWrap" v-if="conf.preText" :style="preFontStyle">
        <span style="color: rgba(0, 0, 0, 0)">{{ conf.preText }}</span
        ><span
          :class="[
            'positionText',
            conf.preTextStyle.alignType == 1
              ? 'top'
              : conf.preTextStyle.alignType == 2
              ? 'center'
              : 'bottom',
          ]"
          >{{ conf.preText }}</span
        >
      </div>
      <div style="display: flex; align-items: flex-end">
        <span :style="integerFontStyle"
          >{{ conf.text >= 0 ? conf.positiveFlag : conf.negativeFlag
          }}{{ integerText }}</span
        >
        <span :style="decimalPointFontStyle">{{ decimalPoint }}</span>
      </div>
      <div
        class="miniWrap"
        v-if="decimal || conf.sufText"
        ref="decimalRef"
        :style="decimalFontStyle"
      >
        <span style="color: rgba(0, 0, 0, 0)"
          >{{ decimal
          }}<span
            v-if="
              conf.sufTextStyle.alignType == 4 ||
              conf.sufTextStyle.alignType == 5
            "
            :style="sufFontStyleUn"
            ><br />{{ conf.sufText }}</span
          ></span
        >
        <span
          :class="['positionText', conf.fontSpecial == 1 ? 'top' : 'bottom']"
          >{{ decimal }}</span
        >
        <span
          v-if="
            conf.sufTextStyle.alignType == 4 || conf.sufTextStyle.alignType == 5
          "
          :class="[
            'positionText',
            conf.sufTextStyle.alignType == 4 ? 'top' : 'bottom',
          ]"
          :style="sufFontStyleUn"
          >{{ conf.sufText }}</span
        >
      </div>
      <div
        class="miniWrap"
        v-if="
          conf.sufText &&
          conf.sufTextStyle.alignType != 4 &&
          conf.sufTextStyle.alignType != 5
        "
        ref="sufRef"
        :style="sufFontStyle"
      >
        <span style="color: rgba(0, 0, 0, 0)">{{ conf.sufText }}</span
        ><span
          :class="[
            'positionText',
            conf.sufTextStyle.alignType == 1
              ? 'top'
              : conf.sufTextStyle.alignType == 2
              ? 'center'
              : conf.sufTextStyle.alignType == 3
              ? 'bottom'
              : '',
          ]"
          >{{ conf.sufText }}</span
        >
      </div>
    </span>
  </div>
</template>

<script>
export default {
  name: "textFloat",
  data() {
    return {
      scale: 1,
    };
  },
  props: {
    conf: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    // 数值计算
    calcNumberFun(num, calcType, calcNum) {
      //  if(isNaN(num))return
      if (isNaN(num) || !num || !calcNum || !calcType || calcNum == 0) {
        return num;
      } else {
        switch (calcType) {
          case "+":
            return parseFloat(num) + parseFloat(calcNum);
          case "-":
            return parseFloat(num) - parseFloat(calcNum);
          case "*":
            return parseFloat(num) * parseFloat(calcNum);
          case "/":
            return parseFloat(num) / parseFloat(calcNum);
          case "%":
            return parseFloat(num) % parseFloat(calcNum);
          default:
            throw new Error("Unknown operation");
        }
      }
    },
    // 整数千分符格式化
    formatWithThousandSeparator(number, separator = ",") {
      // 将数字转换为字符串
      const numStr = number.toString();
      // 使用正则表达式将每三个数字分组，并在每组之间插入分隔符
      return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    },
    // 向上取整方法
    roundUp(initNum, n) {
      const pow = Math.pow(10, n);
      let result = Math.ceil(initNum * pow) / pow;
      result = result.toFixed(n);
      console.log(result);
      return result;
    },
    // 向下取整方法
    roundDown(initNum, n) {
      const pow = Math.pow(10, n);
      let result = Math.floor(initNum * pow) / pow;
      result = result.toFixed(n);
      console.log(result);
      return result;
    },
    // 银行家舍入方法
    halfDown(initNum, n) {
      const pow = Math.pow(10, n);
      let result;
      let decimal = initNum % 1;
      console.log('======todoNum',decimal)
      if (decimal > 0.5) {
        result = Math.ceil(initNum * pow) / pow;
        result = result.toFixed(n);
      } else if (decimal < 0.5) {
        result = Math.floor(initNum * pow) / pow;
        result = result.toFixed(n);
      } else { // 被舍位为5
        const todoNum = Math.floor(initNum * pow) / pow;
        console.log('======todoNum',todoNum)
        if (todoNum % 2 === 0) {
          result = Math.floor(initNum * pow) / pow;
          result = result.toFixed(n);
        } else {
          console.log('======result')
          result = Math.ceil(initNum * pow) / pow;
          console.log(result)
          result = result.toFixed(n);
          console.log(result)
        }
      }
      return result;
    },
    // 超出展示规则changeScale
    changeScale() {
      if (this.conf.exceedingDisplay == 1) {
        // 超出隐藏直接不处理
        this.scale = 1;
        return;
      }
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      // 前缀的宽
      const preText = this.conf.preText;
      const preTextStyle =
        this.conf.preTextStyle.fontSize + "px " + this.conf.preTextStyle.font;
      context.font = preTextStyle;
      const preWidth = context.measureText(preText).width;
      console.log("width1111111");
      console.log(preWidth);
      // 整数的宽
      const integerText =
        (this.conf.text >= 0
          ? this.conf.positiveFlag
          : this.conf.negativeFlag) + this.integerText;
      const integerTextStyle =
        this.conf.integerTextStyle.fontSize +
        "px " +
        this.conf.integerTextStyle.font;
      context.font = integerTextStyle;
      const integerWidth = context.measureText(integerText).width;
      console.log("整数", integerText, integerTextStyle);
      console.log(integerWidth);
      // 小数点的宽
      const decimalPiontText = this.decimalPoint;
      const decimalPointTextStyle =
        this.decimalPointFontStyle.fontSize +
        this.decimalPointFontStyle.fontFamily;
      context.font = decimalPointTextStyle;
      const decimalPointWidth = context.measureText(decimalPiontText).width;
      console.log("小数点", decimalPiontText, decimalPointTextStyle);
      console.log(decimalPointWidth);

      // 小数的宽
      const decimalText = this.decimal;
      const decimalTextStyle =
        this.decimalFontStyle.fontSize + this.decimalFontStyle.fontFamily;
      context.font = decimalTextStyle;
      const decimalWidth = context.measureText(decimalText).width;
      console.log("小数", decimalText, decimalTextStyle);
      console.log(decimalWidth);

      // 后缀的宽
      const sufText = this.decimal;
      const sufTextStyle =
        this.sufFontStyle.fontSize + this.sufFontStyle.fontFamily;
      context.font = sufTextStyle;
      const sufWidth = context.measureText(sufText).width;
      console.log("后缀", sufText, sufTextStyle);
      console.log(sufWidth);

      const mixDecimalSufWidth =
        this.conf.sufTextStyle.alignType == 4 ||
        this.conf.sufTextStyle.alignType == 5
          ? decimalWidth >= sufWidth
            ? decimalWidth
            : sufWidth
          : parseInt(decimalWidth + sufWidth);

      const allWidth =
        Math.ceil(preWidth) +
        Math.ceil(integerWidth) +
        Math.ceil(decimalPointWidth) +
        mixDecimalSufWidth;
      console.log("总宽", allWidth);

      if (allWidth > this.conf.width && this.conf.exceedingDisplay == 2) {
        //exceedingDisplay 2自动缩放
        // const prec = (allWidth - this.conf.width) / this.conf.width;
        const prec = this.conf.width / (parseInt(allWidth) + 20);
        // this.scale = 1 - prec.toFixed(2);
        console.log(prec);
        this.scale = prec.toFixed(2);
      } else {
        this.scale = 1;
      }
    },
  },
  computed: {
    fontStyle() {
      return {
        textDecoration: this.conf.isUnderline,
        // transform: "scale(" + this.scale + ")",
        zoom: this.scale,
      };
    },
    preFontStyle() {
      return {
        fontFamily: `'${this.conf.preTextStyle.font}'`,
        fontSize: this.conf.preTextStyle.fontSize + "px",
        textDecoration: this.conf.preTextStyle.isUnderline,
        fontWeight: this.conf.preTextStyle.isBold ? "bold" : "normal",
        fontStyle: this.conf.preTextStyle.isItaly ? "italic" : "normal",
        position: "relative",
        height: this.conf.integerTextStyle.fontSize + "px",
        lineHeight: "1",
      };
    },
    originalFont() {
      return {
        fontSize: this.conf.fontSize + "px",
        textDecoration: this.conf.isUnderline,
      };
    },

    // "Pre Font Style": "前缀样式",
    //   "Integer Font Style": "整数样式",
    //   "Decimal Point Font Style": "小数点样式",
    //   "Decimal Font Style": "小数样式",
    //   "Suffix Font Style": "后缀样式",

    integerText() {
      let textNum = parseFloat(
        this.conf.text.replace(/#mark#/g, "'").replace(/#marks#/g, '"')
      );
      // 数值取绝对值
      textNum = textNum >= 0 ? textNum : -textNum;

      textNum = parseFloat(
        this.calcNumberFun(textNum, this.conf.calcType, this.conf.calcNumber)
      );
      let textContent = "";
      if (this.conf.roundingMode == 1) {
        // 向上取整
        textContent = this.roundUp(textNum, this.conf.decimalplaces);
      }
      if (this.conf.roundingMode == 2) {
        // 向下取整
        textContent = this.roundDown(textNum, this.conf.decimalplaces);
      }
      if (this.conf.roundingMode == 3) {
        // 四舍五入
        textContent = textNum.toFixed(this.conf.decimalplaces);
      }
      if (this.conf.roundingMode == 4) {
        // 银行家舍入
        textContent = this.halfDown(textNum, this.conf.decimalplaces);
      }
      let idx = textContent.indexOf(this.conf.fontSpecialChar);
      idx = idx > 0 ? idx : textContent.length;

      return this.formatWithThousandSeparator(
        textContent.substring(0, idx),
        this.conf.thousandSeparator
      );
    },
    integerFontStyle() {
      return {
        fontFamily: `'${this.conf.integerTextStyle.font}'`,
        fontSize: this.conf.integerTextStyle.fontSize + "px",
        textDecoration: this.conf.integerTextStyle.isUnderline,
        fontWeight: this.conf.integerTextStyle.isBold ? "bold" : "normal",
        fontStyle: this.conf.integerTextStyle.isItaly ? "italic" : "normal",
        height: this.conf.integerTextStyle.fontSize + "px",
        lineHeight: "1",
      };
    },
    // 小数点文本内容及样式
    decimalPoint() {
      const decimalPoint = this.conf.decimalPoint;
      const decimalplaces = this.conf.decimalplaces;
      return decimalplaces > 0 ? decimalPoint : "";
    },
    decimalPointFontStyle() {
      return {
        fontFamily: `'${this.conf.decimalPointTextStyle.font}'`,
        fontSize: this.conf.decimalPointTextStyle.fontSize + "px",
        fontWeight: this.conf.decimalPointTextStyle.isBold ? "bold" : "normal",
        fontStyle: this.conf.decimalPointTextStyle.isItaly
          ? "italic"
          : "normal",
        // height: this.conf.integerTextStyle.fontSize + "px",
        lineHeight: "1",
      };
    },

    // 小数文本内容及样式
    decimal() {
      let textNum = parseFloat(
        this.conf.text.replace(/#mark#/g, "'").replace(/#marks#/g, '"')
      );
      textNum = parseFloat(
        this.calcNumberFun(textNum, this.conf.calcType, this.conf.calcNumber)
      );
      let textContent = "";
      if (this.conf.roundingMode == 1) {
        // 向上取整
        textContent = this.roundUp(textNum, this.conf.decimalplaces);
      }
      if (this.conf.roundingMode == 2) {
        // 向下取整
        textContent = this.roundDown(textNum, this.conf.decimalplaces);
      }
      if (this.conf.roundingMode == 3) {
        // 四舍五入
        // console.log(textNum)
        // console.log(this.conf.decimalplaces)
        // console.log(textNum.toFixed(this.conf.decimalplaces))
        // console.log(Number(textNum.toPrecision(this.conf.decimalplaces)))
        textContent = textNum.toFixed(this.conf.decimalplaces);
      }
      if (this.conf.roundingMode == 4) {
        // 银行家舍入
        textContent = this.halfDown(textNum, this.conf.decimalplaces);
      }
      let idx = textContent.indexOf(this.conf.fontSpecialChar);
      idx = idx > 0 ? idx : textContent.length;
      return textContent.substring(idx + 1, textContent.length);
    },
    decimalFontStyle() {
      // decimalTextStyle
      return {
        fontFamily: `'${this.conf.decimalTextStyle.font}'`,
        fontSize: this.conf.decimalTextStyle.fontSize + "px",
        textDecoration: this.conf.decimalTextStyle.isUnderline,
        fontWeight: this.conf.decimalTextStyle.isBold ? "bold" : "normal",
        fontStyle: this.conf.decimalTextStyle.isItaly ? "italic" : "normal",
        position: "relative",
        height: this.conf.integerTextStyle.fontSize + "px",
        lineHeight: "1",
      };
    },

    sufFontStyleUn() {
      return {
        fontFamily: `'${this.conf.sufTextStyle.font}'`,
        fontSize: this.conf.sufTextStyle.fontSize + "px",
        textDecoration: this.conf.sufTextStyle.isUnderline,
        fontWeight: this.conf.sufTextStyle.isBold ? "bold" : "normal",
        fontStyle: this.conf.sufTextStyle.isItaly ? "italic" : "normal",
      };
    },

    sufFontStyle() {
      return {
        fontFamily: `'${this.conf.sufTextStyle.font}'`,
        fontSize: this.conf.sufTextStyle.fontSize + "px",
        textDecoration: this.conf.sufTextStyle.isUnderline,
        fontWeight: this.conf.sufTextStyle.isBold ? "bold" : "normal",
        fontStyle: this.conf.sufTextStyle.isItaly ? "italic" : "normal",
        position: "relative",
        height: this.conf.integerTextStyle.fontSize + "px",
        lineHeight: "1",
      };
    },

    suffixAlign() {
      const alignType = this.conf.sufTextStyle.alignType;
      if (alignType == 4 || alignType == 5) {
        console.log("!!!!!!!!!!!!!!!!");
        return true;
      }
      return false;
    },

    fontSpecialStyle() {
      return {
        fontSize: this.conf.fontSpecialSize + "px",
      };
    },
    spcialType() {
      return this.conf.fontSpecial === 0
        ? "auto"
        : this.conf.fontSpecial === 1
        ? "top"
        : this.conf.fontSpecial === 2
        ? "bottom"
        : "";
    },
  },
  watch: {
    "conf.text"() {
      this.conf.text = this.conf.text
        .replace(/\r\n/g, "#line#")
        .replace(/\n/g, "#line#")
        .replace(/\t/g, "#line#")
        .replace(/'/g, "#mark#")
        .replace(/\"/g, "#marks#");
    },
    "conf.exceedingDisplay"() {
      this.changeScale();
    },
    conf: {
      handler() {
        // console.group('开始变化scale')
        this.changeScale();
        // console.groupEnd('结束了')
      },
      deep: true,
    },
    // "conf.preText"(){

    // },
    // "conf.positiveFlag"(){
    //   this.changeScale()
    // },
    // "conf.negativeFlag"(){
    //   this.changeScale()
    // },
    // integerText(){
    //   this.changeScale()
    // },
    // "conf.decimalPoint"(){
    //   this.changeScale()
    // },
    // decimal(){
    //   this.changeScale()
    // },
    // "conf.sufText"(){
    //   this.changeScale()
    // },
  },
  filters: {
    htmlFix(html) {
      return html
        .replace(/#line#/g, "\n")
        .replace(/#mark#/g, "'")
        .replace(/#marks#/g, '"');
    },
  },
  mounted() {
    // console.log('我来看看数字计算结果：',1299.9%2)
    this.changeScale();
  },
};
</script>

<style scoped lang="scss">
.text-float {
  position: relative;
  .flex {
    display: flex;
    // align-items: flex-end;
    // align-items: baseline;
    align-items: center;
  }
  .miniWrap {
    display: flex;
    align-items: flex-end;
  }
  .top.positionText {
    position: absolute;
    top: 0;
    left: 0;
  }
  .center.positionText {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }
  .bottom.positionText {
    position: absolute;
    bottom: 0;
    left: 0;
  }
}
</style>
